import { render, staticRenderFns } from "./BoschLogsComponent.vue?vue&type=template&id=134fd7e3"
import script from "./BoschLogsComponent.vue?vue&type=script&lang=js"
export * from "./BoschLogsComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports